/**
 * Auth Actions
 * Auth Action With Google, Facebook, Twitter and Github
 */
import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILURE,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  LOGOUT_USER_FAILURE,
  RESET_PASSWORD_STEP_ONE,
  RESET_PASSWORD_STEP_ONE_SUCCESS,
  RESET_PASSWORD_STEP_ONE_FAILURE,
  RESET_PASSWORD_STEP_TWO,
  RESET_PASSWORD_STEP_TWO_SUCCESS,
  RESET_PASSWORD_STEP_TWO_FAILURE,
  CREATE_ACCOUNT_FAILURE,
  CREATE_ACCOUNT,
  CREATE_ACCOUNT_SUCCESS,
  CREATE_NEW_PASSWORD,
  GET_NEW_PASSWORD
} from "./types";

export const signinUserInCognito = (user, history) => ({
  type: LOGIN_USER,
  payload: { user, history }
});

/**
 * Redux Action Signin User Success
 */
export const signinUserSuccess = (user) => ({
  type: LOGIN_USER_SUCCESS,
  payload: user
});

export const signinUserFailure = (error) => ({
  type: LOGIN_USER_FAILURE,
  payload: error
});

export const logoutUserFromCognito = (history) => ({
  type: LOGOUT_USER,
  payload: { history }
});

export const logoutUserFromCognitoSuccess = () => ({
  type: LOGOUT_USER_SUCCESS
});

export const logoutUserFromCognitoFailure = () => ({
  type: LOGOUT_USER_FAILURE
});

/**
 * 
 * Creates the new password on the user's first login
 */
export const getNewPassword = (user) => ({
  type: GET_NEW_PASSWORD,
  payload: user
});

export const createNewUserPassword = (user, history) => ({
  type: CREATE_NEW_PASSWORD,
  payload: { user, history }
});

/**
 * Reset password section
 */
export const resetPasswordStepOneFailure = (error) => ({
  type: RESET_PASSWORD_STEP_ONE_FAILURE,
  payload: error
});

export const resetPasswordStepOne = (user, history) => ({
  type: RESET_PASSWORD_STEP_ONE,
  payload: { user, history }
});

export const resetPasswordStepOneSuccess = (deliveryMedium) => ({
  type: RESET_PASSWORD_STEP_ONE_SUCCESS,
  payload: { deliveryMedium: deliveryMedium }
});

export const resetPasswordStepTwoFailure = (error) => ({
  type: RESET_PASSWORD_STEP_TWO_FAILURE,
  payload: error
});

export const resetPasswordStepTwo = (user, history) => ({
  type: RESET_PASSWORD_STEP_TWO,
  payload: { user, history }
});

export const resetPasswordStepTwoSuccess = () => ({
  type: RESET_PASSWORD_STEP_TWO_SUCCESS
});

export const createAccountFailure = (error) => ({
  type: CREATE_ACCOUNT_FAILURE,
  payload: error
});

export const createAccount = (user, history) => ({
  type: CREATE_ACCOUNT,
  payload: { user, history }
});

export const createAccountSuccess = () => ({
  type: CREATE_ACCOUNT_SUCCESS
});
